export const CREDIT_NOTE_PREFIX = 'NC'

export function withCreditNotePrefix(value) {
    const text = value == null ? '' : String(value).trim()
    if (!text) return CREDIT_NOTE_PREFIX
    if (text.toUpperCase().startsWith(CREDIT_NOTE_PREFIX)) return text
    return `${CREDIT_NOTE_PREFIX}${text}`
}

export function withoutCreditNotePrefix(value) {
    const text = value == null ? '' : String(value).trim()
    if (!text) return ''
    if (text.toUpperCase().startsWith(CREDIT_NOTE_PREFIX)) {
        return text.slice(CREDIT_NOTE_PREFIX.length)
    }
    return text
}
